import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { toString } from '@carbon/icon-helpers';
import { icons16 } from './carbon-icons';

export const iconLoader = (domSanitizer: DomSanitizer, registry: MatIconRegistry) => () => {
  icons16.forEach(icon => {
    registry.addSvgIconLiteral(icon.name, domSanitizer.bypassSecurityTrustHtml(toString(icon)), {
      viewBox: icon.attrs?.viewBox,
    });
  });

  // Register custom icons
  registry.addSvgIcon(
    'abort-transaction',
    domSanitizer.bypassSecurityTrustResourceUrl('assets/carbon-icons/abort-transaction.svg'),
  );
  registry.addSvgIcon(
    'submit-transaction',
    domSanitizer.bypassSecurityTrustResourceUrl('assets/carbon-icons/submit-transaction.svg'),
  );
  registry.addSvgIcon(
    're-queue-transaction',
    domSanitizer.bypassSecurityTrustResourceUrl('assets/carbon-icons/re-queue-transaction.svg'),
  );
  registry.addSvgIcon(
    'network-tier',
    domSanitizer.bypassSecurityTrustResourceUrl('assets/carbon-icons/network-tier.svg'),
  );
  registry.addSvgIcon(
    'user-add',
    domSanitizer.bypassSecurityTrustResourceUrl('assets/carbon-icons/user-add.svg'),
  );
  registry.addSvgIcon(
    'user-multiple-add',
    domSanitizer.bypassSecurityTrustResourceUrl('assets/carbon-icons/user-multiple-add.svg'),
  );
  registry.addSvgIcon(
    'change-status',
    domSanitizer.bypassSecurityTrustResourceUrl('assets/carbon-icons/change-status.svg'),
  );
  registry.addSvgIcon(
    '3-d-mpr-toggle',
    domSanitizer.bypassSecurityTrustResourceUrl('assets/carbon-icons/3-d-mpr-toggle.svg'),
  );
  registry.addSvgIcon(
    'error-filled',
    domSanitizer.bypassSecurityTrustResourceUrl('assets/carbon-icons/error-filled.svg'),
  );
  registry.addSvgIcon(
    'warning-filled',
    domSanitizer.bypassSecurityTrustResourceUrl('assets/carbon-icons/warning-filled.svg'),
  );
  registry.addSvgIcon(
    'sequence-marker',
    domSanitizer.bypassSecurityTrustResourceUrl('assets/carbon-icons/sequence-marker.svg'),
  );
  registry.addSvgIcon(
    'downleft-topright',
    domSanitizer.bypassSecurityTrustResourceUrl('assets/carbon-icons/downleft-topright.svg'),
  );
};
